<div class="adc-tooltip" [attr.data-tooltip]="tooltipText" (mouseover)="onMouseOver($event)">
    <ng-content></ng-content>
</div>